var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccessLevelIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)",
    stroke: "#D2D2D9",
    strokeWidth: 2.75,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#EEF0F3",
    width: 79.13,
    height: 18.261,
    rx: 6.087
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 60.87,
    y: 73.043,
    width: 79.13,
    height: 18.261,
    rx: 6.087
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#EEF0F3",
    x: 60.87,
    y: 121.739,
    width: 79.13,
    height: 18.261,
    rx: 6.087
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.478 91.304v30.435M42.609 18.267v27.391a9.13 9.13 0 0 0 9.13 9.13h42.609a9.13 9.13 0 0 1 9.13 9.131v9.13"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessLevelIcon);
export default __webpack_public_path__ + "static/media/access-level-icon.a03d6e9d663cd41b8e1847f08903f8fb.svg";
export { ForwardRef as ReactComponent };